module.exports = __webpack_public_path__ + "static/media/inner_35.83812855.jpg";